import { IconPortfolio } from '@hubble/icons';
import { useState } from 'react';
import { IconBadge } from '../IconBadge/index.js';
import { CDN_URL } from '../shared/constants.js';
import { StyledImg } from '../shared/styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const getSrc = (symbol, imageType, cache) => `${CDN_URL}/${symbol}.${imageType}?cache=${cache}`;
const CryptoIcon = ({
  size = 'lg',
  symbol,
  className,
  imageType = 'svg',
  cache = '2025-09-08'
}) => {
  const src = getSrc(symbol, imageType, cache);
  const [imgLoadError, setImgLoadError] = useState(false);
  if (imgLoadError) return jsx(IconBadge, {
    icon: jsx(IconPortfolio, {}),
    size: size
  });
  return jsx(StyledImg, {
    src: src,
    className: className,
    alt: symbol,
    onError: () => setImgLoadError(true),
    size: size
  });
};
CryptoIcon.displayName = 'CryptoIcon';

export { CryptoIcon };
